shadow$provide[360] = function(require,module,exports) {
Object.defineProperties(exports, {__esModule:{enumerable:true, value:true}, Factory:{enumerable:true, get:function() {
  return require$_DOT__SLASH_factory_DOT_js.RenderFactory;
}}});
var require$_DOT__SLASH_scene_DOT_js = require("./scene.js");
var require$_DOT__SLASH_factory_DOT_js = require("./factory.js");
var require$_DOT__SLASH_classes_DOT_js = require("./classes.js");
require.exportCopy(module, require$_DOT__SLASH_scene_DOT_js);
require.exportCopy(module, require$_DOT__SLASH_scene_DOT_js);
require.exportCopy(module, require$_DOT__SLASH_classes_DOT_js);

};